import apiClient from "./axiosConfig";

const extractList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.links)) return response.data.links;
  if (Array.isArray(response?.links)) return response.links;
  if (Array.isArray(response?.results)) return response.results;
  return [];
};

// GET /api/products/links/search/
export const searchProductsForLinking = async (params = {}) => {
  const queryParams = new URLSearchParams();
  const search = (params.search || "").trim();
  if (!search) {
    throw new Error("search is required");
  }
  queryParams.append("search", search);

  if (params.from_product != null) {
    queryParams.append("from_product", params.from_product);
  }
  if (params.category_id != null) {
    queryParams.append("category_id", params.category_id);
  }
  if (params.brand_id != null) {
    queryParams.append("brand_id", params.brand_id);
  }
  if (params.unique_identifier_id != null) {
    queryParams.append("unique_identifier_id", params.unique_identifier_id);
  }

  const response = await apiClient.get(
    `/products/links/search/?${queryParams.toString()}`
  );
  return extractList(response.data);
};

// POST /api/products/links/
export const createProductLinks = async ({ from_product, links }) => {
  const response = await apiClient.post("/products/links/", {
    from_product,
    links,
  });
  return response.data;
};

// GET /api/products/links/
export const getProductLinks = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.product_id == null) {
    throw new Error("product_id is required");
  }
  queryParams.append("product_id", params.product_id);

  if (params.basic_detail) queryParams.append("basic_detail", "1");
  if (params.to_display) queryParams.append("to_display", "1");
  if (params.to_update_price) queryParams.append("to_update_price", "1");
  if (params.page) queryParams.append("page", params.page);
  if (params.page_size) queryParams.append("page_size", params.page_size);

  const response = await apiClient.get(
    `/products/links/?${queryParams.toString()}`
  );
  return extractList(response.data);
};

// PATCH /api/products/links/
export const updateProductLinks = async ({ from_product, links }) => {
  const response = await apiClient.patch("/products/links/", {
    from_product,
    links,
  });
  return response.data;
};

// DELETE /api/products/links/<link_id>/
export const deleteProductLink = async (linkId) => {
  const response = await apiClient.delete(`/products/links/${linkId}/`);
  return response.data;
};
